<template>
  <div class="news">
    <div class="banner">
      <img
        class="banner_img"
        src="../../static/img/hzhb_xxpl_banner.png"
        alt=""
      >
    </div>
    <!-- -->
    <div
      class="pl_con w1200"
      v-for="(item,i) in plList"
      :key="i"
      v-if="$route.query.id - 0 === i"
    >
      <h4>{{item.title}}</h4>
      <div
        class="cont"
        v-if="$route.query.id === '0'"
      >
        <p style="text-indent:0;color:#4a86c5;">一、公司及服务介绍</p>
        <p>（一）公司介绍</p>
        <p>中国人民财产保险股份有限公司（PICC P&C，简称“中国人保财险”）的前身是1949年10月20日成立的中国人民保险公司，是“世界500强”中国人民保险集团股份有限公司（PICC）的核心成员和标志性主业。2003年，中国人保财险在香港联交所主板挂牌上市（股票代码2328）。2016年，公司实现发展新跨越，保费收入突破3000亿元。</p>

        <p>中国人保财险始终坚持党的领导，始终坚决服从并贯彻落实党的大政方针和国家各项决策部署，牢记“人民保险 服务人民”的历史使命，坚持以市场为导向、以客户为中心，积极履行政治、经济和社会责任，做全面建设小康社会的推动者，做国家治理和社会管理的参与者，为经济发展、社会稳定、国家强盛、人民幸福提供了强大的保险保障。同时，在服务经济社会发展大局、服务民生和广大客户的实践中，中国人保财险在车辆保险、三农保险、巨灾保险、大病保险、责任保险、普惠金融和扶贫支农等主营业务方面不断取得突破，承保领域不断拓宽，涉及社会生产和人民生活的各个领域，在国内财险市场上形成了独特的、具有鲜明特色的公司核心竞争优势。</p>
        <p>（二）公司官网（投保咨询、保单查询及客户投诉）</p>
        <p> http://www.epicc.com.cn/</p>
        <p>（三）机构网点信息：见如下网页</p>

        <p>http://www.epicc.com.cn/renbao/jigouwangdian/</p>
        <p>（四）本合同保费为一次性支付，合同采用纸质保单的形式承保。保单和保险费发票在您投保后的2个工作日送达您手中。</p>

        <p>（五）如发现自身权益受到侵犯，请您保留相关证据并向本公司投诉，投诉电话：95518。</p>
        <p>（六）退保及理赔方式：线下退保，服务电话：95518，赔款支付方式为转账付款。</p>

        <p style="text-indent:0;color:#4a86c5;">二、产品销售信息</p>
        <p>如实告知义务：</p>
        <p>1.提示投保人如实、准确提供如下信息，并对投保人告知的信息进行核对。</p>
        <p>
        2.投保人和被保险人的姓名、身份证、联系电话等人员信息。</p>
       <p>
        3.被保险车辆种类、型号、牌照号码、使用性质等车辆信息及投保的险别信息。</p>
        <p>
        4.协助投保人通过填写投保单并以签字确认的形式履行书面告知义务，通过网络渠道承保的，应提示投保人通过点击相关网页网络链接，确认已履行如实告知义务。
      </p>
        <p>违反义务的后果：</p>

        <p>1.投保人故意或因重大过失未履行如实告知义务，足以影响保险人决定是否同意承保或提高费率的，保险人有权解除合同。 </p>
        <p> 2.投保人故意不履行如实告知义务的，保险人对于合同解除前发生的保险事故，不承担赔偿保险金的责任，并且不退还保险费。</p>
        <p>3.投保人因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，保险人对于合同解除前发生的保险事故，不承担赔偿保险金的责任，但退还保险费。</p>
        <p>信息安全：</p>
        <p>我们严格遵守现行的关于个人信息、数据及隐私保护的法律法规，采取充分的技术手段和制度管理，保护您提供给我们的个人信息、数据和隐私不受到非法的泄露或披露给未获授权的第三方。 </p>
        <p style="text-indent:0;color:#4a86c5;">三、投保流程</p>
        <p>1.填写资料</p>
        <p>2.精准报价</p>
        <p>3.确认支付</p>
        <p>4.查收保单</p>

        <p style="text-indent:0;color:#4a86c5;">四、理赔流程</p>
        <p>1.拨打95518报案</p>
        <p> 2.配合警方和安盛天平保险公司进行事故处理及损失计算</p>
        <p>3.事故车辆维修和受伤人员治疗</p>
        <p>4.提交索赔资料进行审核</p>
        <p>5.领取索赔款</p>
      </div>
      <div
        class="cont"
        v-if="$route.query.id === '1'"
      >
        <p style="text-indent:0;color:#4a86c5;"> 一、合作公司及服务介绍</p>

        <p>（一）公司介绍</p>
        <p>中华保险，全称为中华联合保险控股股份有限公司，全国唯一一家以“中华”冠名的保险公司，始创于1986年7月15日，是我国成立的第二家具有独立法人资格的国有控股保险公司。公司旗下设有中华联合财产保险股份有限公司、中华联合人寿保险股份有限公司、万联电子商务股份有限公司，正在申请筹建的资产管理公司和农险公司。</p>
        <p>（二）公司官网（投保咨询、保单查询及客户投诉）</p>
        <p> http:// www.cic.cn</p>
        <p>（三）机构网点信息：见如下网页</p>
        <p> http://property.cic.cn/publish/portal0/tab120/</p>
        <p>（四）保单及凭证的配送说明：</p>
        <p>电子保单：“保险单证、保险费发票等默认不予配送，如您需要纸质保单可凭借被保险人身份证原件前往我公司当地营业厅进行索取。”</p>
        <p>纸质保单：“保险单证、保险费发票等由合作的快递公司进行配送或可上营业厅取单，配送不另收费用。”</p>
        <p>（五）投保、退保及理赔方式：在线投保、线下退保；理赔为转账付款。全国24小时服务电话：95585。</p>
        <p>（六）中华联合财产保险股份有限公司已采取相应的技术、网络等风控措施，确保客户的个人信息、投保交易信息和交易安全。</p>

        <p style="text-indent:0;color:#4a86c5;">二、产品销售信息</p>
        <p>（一）合作公司为：中华联合财产保险股份有限公司</p>
        <p>（二）产品信息</p>
        <p>合作产品信息为：机动车辆保险</p>
        <p>保险产品条款：中国保险行业协会机动车综合商业保险示范条款</p>
        <p>审批/备案编号：H2015102</p>
        <p>（三）其他</p>
        <p>投保人需遵守如实告知义务，如违反如实告知义务，则按《保险法》相关规定处理。</p>
      </div>
      <div
        class="cont"
        v-if="$route.query.id === '2'"
      >
        <p>一、公司名称：</p>

        <p>中国太平保险集团有限责任公司</p>
        <p>二、注册资本：</p>
        <p>人民币贰佰伍拾贰亿陆仟零柒拾伍万元整</p>
        <p>三、法定代表人</p>
        <p>王滨</p>
        <p> 四、经营范围</p>
        <p> 本公司及下属子公司的业务范围涵盖寿险、财险、养老保险、再保险、再保险经纪及保险代理、互联网保险、资产管理、证券经纪、金融租赁、不动产投资、养老产业投资等。</p>
        <p> 五、基本财务数据</p>
        <p>2016年，中国太平实现总保费1,275亿元人民币，截至2016年底，集团总资产超过4,500亿元人民币。</p>
        <p> 六、客服热线</p>
        <p> 95589</p>
        <p> 七、公司网址</p>
        <p> http://www.cntaiping.com/</p>
      </div>
      <div
        class="cont"
        v-if="$route.query.id === '3'"
      >
        <p style="text-indent:0;color:#4a86c5;">公司及服务介绍</p>
        <p>（一）公司介绍</p>
        <p>安盛天平由原中国第一家专业车险公司天平汽车保险与国际领先保险集团AXA安盛集团在华全资财产险子公司合并而设立。依托AXA安盛集团雄厚的财务实力，卓越的品牌价值和领先的专业能力，并融合了天平保险丰富的本土经验资源和服务网络，致力于为广大客户提供及时、便捷、值得信赖的保险服务。</p>
        <p>公司总部设在上海浦东陆家嘴金融区，注册资本8.46亿元，主要经营机动车交通事故责任强制保险、机动车商业保险和企业财产险、家财险、货运险、责任险、短期意外险、健康险等业务。</p>
        <p>（二）公司官网（投保咨询、保单查询及客户投诉）</p>
        <p>http://www.axatp.com/</p>
        <p>（三）机构网点信息：见如下网页</p>
        <p> http://www.axatp.com/about_us/branch.html</p>
        <p>（四）本合同保费为一次性支付，合同采用纸质保单的形式承保。保单和保险费发票在您投保后的2个工作日送达您手中。</p>
        <p>（五）如发现自身权益受到侵犯，请您保留相关证据并向本公司投诉，投诉电话：95550。</p>
        <p>（六）退保及理赔方式：线下退保，服务电话：95550，赔款支付方式为转账付款。</p>
        <p style="text-indent:0;color:#4a86c5;"> 产品销售信息</p>
        <p> 合作产品</p>
        <p> 【安盛天平车险】商业险 交强险 优惠套餐 汽车保险，报备文件编号为保监产险【2009】990号、保监许可【2015】458号，保监许可【2015】1304号。</p>
        <p>如实告知义务：</p>
        <p>1.提示投保人如实、准确提供如下信息，并对投保人告知的信息进行核对。</p>
        <p>2.投保人和被保险人的姓名、身份证、联系电话等人员信息。</p>
        <p>3.被保险车辆种类、型号、牌照号码、使用性质等车辆信息及投保的险别信息。</p>
        <p>4.协助投保人通过填写投保单并以签字确认的形式履行书面告知义务，通过网络渠道承保的，应提示投保人通过点击相关网页网络链接，确认已履行如实告知义务。</p>
        <p>违反义务的后果：</p>
        <p> 1.投保人故意或因重大过失未履行如实告知义务，足以影响保险人决定是否同意承保或提高费率的，保险人有权解除合同。</p>
        <p> 2.投保人故意不履行如实告知义务的，保险人对于合同解除前发生的保险事故，不承担赔偿保险金的责任，并且不退还保险费。</p>
        <p>3.投保人因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，保险人对于合同解除前发生的保险事故，不承担赔偿保险金的责任，但退还保险费。</p>
        <p>信息安全：</p>
        <p>我们严格遵守现行的关于个人信息、数据及隐私保护的法律法规，采取充分的技术手段和制度管理，保护您提供给我们的个人信息、数据和隐私不受到非法的泄露或披露给未获授权的第三方。</p>
        <p>投保流程</p>
        <img src="../../static/img/as.png" alt="">
        <p>理赔流程</p>
         <img src="../../static/img/as_1.png" alt="">
      </div>
      <div
        class="cont"
        v-if="$route.query.id === '4'"
      >
        <p>一、 法定名称及缩写

          <p>鼎和财产保险股份有限公司DINGHE PROPERTY INSURANCE CO., LTD.</p>
          <p>鼎和保险 DHIC</p>
          <p>二、 注册资本：30.18亿元</p>
          <p>三、 注 册 地：深圳</p>
          <p> 公司住所：深圳市福田区福华三路100号鼎和大厦36-40层</p>
          <p>四、 成立时间：2008年5月22日</p>
          <p>五、 经营范围和区域：</p>
          <p>经营范围：在全国范围内经营财产损失保险；责任保险；信用保险和保证保险；短期健康保险和意外伤害保险；上述业务的再保险业务；国家法律法规允许的保险资金运用业务；经中国保监会批准的其他业务。</p>
          <p>经营区域：广东、广西、云南、贵州、海南、深圳、四川、上海、湖北、河南、江西、陕西、山东、河北。</p>
          <p>六、 法定代表人：王晓锦</p>
          <p>七、 客服电话和投诉电话：95393</p>
          <p> 投诉渠道：鼎和财险全国统一客户投诉电话：95393-7</p>
          <p>官网投诉平台：鼎和保险官网首页www.edhic.com>在线客服>其他问题>我要投诉</p>
          <p>信函及接待地址、传真号码、投诉受理电子邮箱等投诉渠道，请关注各省级分公司及分支机构公布信息。</p>

          <p>投诉处理程序（一般投诉）：</p>
          <p>1.登记投诉</p>
          <p> 2.受理投诉</p>
          <p> 3.调查核实</p>
          <p> 4.协调处理</p>
          <p> 5.告知客户</p>
          <p> 6.确认结果</p>
      </div>
      <div
        class="cont"
        v-if="$route.query.id === '5'"
      >
        <p> 一、法定名称及缩写

          <p> 中文名称：紫金财产保险股份有限公司</p>
          <p> 缩写：紫金保险</p>
          <p> 二、注册资本：25亿元人民币</p>
          <p> 三、注册地：江苏省南京市建邺区兴隆大街188号奥体邻里中心综合楼1-4层</p>
          <p>四、成立时间：2009年5月8日</p>
          <p>五、经营范围和经营区域</p>
          <p>经营范围：按照《中华人民共和国保险法》、《保险公司管理规定》及中国保险监督管理委员会有关规范性文件的规定， 公司经营下列全部或部分保险业务：</p>
          <p> (一)财产损失保险；</p>
          <p> (二)责任保险；</p>
          <p> (三)信用保险和保证保险；</p>
          <p> (四)短期健康保险和意外伤害保险；</p>
          <p> (五)上述保险业务的再保险业务；</p>
          <p> (六)国家法律和法规允许的保险资金运用业务；</p>
          <p> (七)经中国保险监督管理委员会批准的其他业务。</p>
          <p> 经营区域： +</p>
          <p> 江苏、北京、浙江、宁波、上海、河北、广东、山东、四川、安徽、河南、湖北、福建、湖南、青岛、内蒙古、天津、辽宁、广西、山西、深圳、厦门、云南。</p>
          <p> 六、法定代表人：李明耀</p>
          <p> 七、公司官网：http://www.zking.com/</p>
          <p> 八、客服电话和投诉电话 95312</p>
      </div>
      <div
        class="cont"
        v-if="$route.query.id === '6'"
      >
        <p>1.法定中文名称：利宝保险有限公司 缩写：利宝保险</p>

        <p>2.注册资本：壹拾伍亿零壹佰叁拾叁万叁仟元人民币</p>

        <p> 3.注册地：重庆市渝中区中山三路131号庆隆希尔顿商务中心35层</p>

        <p> 4.成立时间：2003年12月，美国利宝互助保险公司在中国重庆设立分公司，成为重庆地区唯一的一家外资财产保险公司。2007年7月，经中国保险监督管理委员会的批准，美国利宝互助保险公司在中国的分公司正式改建为在中国的全资子公司-利宝保险有限公司。2007年9月改建工作全部完成。</p>

        <p> 5.经营范围：除法定保险业务以外的下列保险业务</p>

        <p>（1）财产损失保险、责任保险（包括机动车交通事故责任强制保险）、信用保险、保证保险等财产保险业务</p>

        <p>（2）短期健康保险、意外伤害保险</p>

        <p>（3）上述业务的再保险业务</p>

        <p> 经营区域：重庆、北京、浙江、广东、山东、四川</p>

        <p> 6.法定代表人：Daniel Martin Bridger</p>

        <p> 7.客服电话和投诉电话：400 888 2008</p>
      </div>

      <div
        class="cont"
        v-if="$route.query.id === '7'"
      >
        <p> 1.法定名称</p>
        <p> 中文名称：众安在线财产保险股份有限公司</p>

        <p> 2.注册资本</p>

        <p> 注册资本人民币14.698129亿元</p>

        <p>3. 公司住所和营业场所</p>

        <p> 上海市黄浦区圆明园路169号协进大楼4-5楼</p>

        <p> 4.成立时间
        </p>
        <p> 二零一三年十月九日</p>

        <p> 5.经营范围和经营区域</p>
        <p> 经营范围：与互联网交易直接相关的企业/家庭财产保险、货运保险、责任保险、信用保证保险、短期健康/意外伤害保险；机动车保险，包括机动车交通事故责任强制保险和机动车商业保险;上述业务的再保险分出和再保险分入业务（仅限临时分保分入）；国家法律、法规允许的保险资金运用业务；保险信息服务业务;经中国保监会批准的其他业务。</p>
        <p> 经营区域：在中华人民共和国境内（港、澳、台地区除外）开展与互联网交易直接相关的保险业务，不设分支机构。</p>

        <p>6.法定代表人</p>

        <p> 欧亚平</p>
        <p>7.客服电话、投诉电话和投诉处理程序</p>

        <p>客服电话：1010-9955</p>

        <p>投诉电话：021-80399188</p>

        <p>投诉处理程序：投诉受理流程</p>

        <p>8 .各分支机构营业场所和联系电话
        </p>
        <p>不设分支机构</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      plList: [
        {
          id: 0,
          title: "中国人保财险信息披露"
        },
        {
          id: 1,
          title: "中华联合保险信息披露"
        },
        {
          id: 2,
          title: "中国太平保险信息披露"
        },
        {
          id: 3,
          title: "安盛天平保险信息披露"
        },
        {
          id: 4,
          title: "鼎和财产保险信息披露"
        },
        {
          id: 5,
          title: "紫金财产保险信息披露"
        },
        {
          id: 6,
          title: "利宝保险信息披露"
        },
        {
          id: 7,
          title: "众安在线财产保险信息披露"
        }
      ]
    };
  }
};
</script>

<style  lang="scss" scoped>
.pl_con {
  background-color: #fff;
  padding: 60px 40px;
  h4 {
    color: #477dbd;
    font-size: 30px;
    text-align: center;
    // font-weight: 600;
    line-height: 70px;
  }
  .cont {
      p{
        font-size: 22px;
        color: #666666;
        text-indent: 2em;
        line-height: 42px;

      }
      img{
          display: block;
          margin: 30px auto;
      }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Cooperative.vue